'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dPage$0024 from "./presto.-Audit-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002443 from "./presto.-Presto-Router$$anon$43.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$42() {
  this.bhu = null;
  this.bhm = null;
  this.bhn = false;
  this.bhv = null;
  this.bhw = false;
  this.bhz = null;
  this.bhs = null;
  this.bht = false;
  this.bho = null;
  this.bhp = false;
  this.bhq = null;
  this.bhr = false;
  this.bhx = false;
  this.bhy = false;
  this.bhu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bhz = "AuditPage";
}
export { $c_Lpresto_PrestoRouter$$anon$42 as $c_Lpresto_PrestoRouter$$anon$42 };
$p = $c_Lpresto_PrestoRouter$$anon$42.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$42;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$42() {
}
export { $h_Lpresto_PrestoRouter$$anon$42 as $h_Lpresto_PrestoRouter$$anon$42 };
$h_Lpresto_PrestoRouter$$anon$42.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bhu;
});
$p.M = (function() {
  if ((!this.bhn)) {
    this.bhm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bhn = true;
  }
  return this.bhm;
});
$p.O = (function() {
  if ((!this.bhw)) {
    this.bhv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bhw = true;
  }
  return this.bhv;
});
$p.E = (function() {
  return this.bhz;
});
$p.t = (function() {
  if ((!this.bht)) {
    this.bhs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bht = true;
  }
  return this.bhs;
});
$p.N = (function() {
  if ((!this.bhp)) {
    this.bho = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhp = true;
  }
  return this.bho;
});
$p.Q = (function() {
  if ((!this.bhr)) {
    this.bhq = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002443.$c_Lpresto_PrestoRouter$$anon$43();
    this.bhr = true;
  }
  return this.bhq;
});
$p.v = (function() {
  if ((!this.bhy)) {
    this.bhx = false;
    this.bhy = true;
  }
  return this.bhx;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee363) => ((p) => \u03b4scrutinee363))($j_presto$002e$002dAudit$002dPage$0024.$m_Lpresto_AuditPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$42 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$42, "presto.PrestoRouter$$anon$42", ({
  Oi: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$42 as $d_Lpresto_PrestoRouter$$anon$42 };
//# sourceMappingURL=presto.-Presto-Router$$anon$42.js.map
